import axios from 'axios';
import Cookies from 'js-cookie';
import errorHandler from '@/assets/data/errorHandler';
// import store from '@/store'
import ValidationError from './ValidationError';

const NetworkPlugin = {
    install(vue, options) {

        const httpClient = axios.create({
            baseURL: options.baseUrl
        });

        httpClient.interceptors.request.use(function (config) {
            if (options.sessionCookie) {
                const accessToken = Cookies.get(options.sessionCookie);
                if (accessToken) {
                    config.headers['Authorization'] = `Bearer ${accessToken}`;
                }
            }
            return config;
        });

        httpClient.interceptors.response.use(function(response) {
            return response;
        }, (error) => {
            let errorResponse = (error.response) ?? error;
            let errorStatus = '';
            let endpoint = '';
            if (errorResponse && errorResponse.status) {
                errorStatus = errorResponse.status;
            }
            if (errorResponse && errorResponse.config && errorResponse.config.url) {
                endpoint = errorResponse.config.url;
            }

            // if (errorStatus === 401) {
            //     store.dispatch('auth/logout');
            // } else {
                let message = errorHandler["default_500"];
                if (errorStatus >= 400 && errorStatus < 500) {
                    let endpointJson = errorHandler[endpoint];
                    if (endpointJson) {
                        let method = (errorResponse.config && errorResponse.config.method) ?? '';
                        let methodJson = endpointJson[method];
                        if (methodJson) {
                            let messageError = methodJson[errorStatus] ?? '';
                            if (messageError) {
                                message = messageError;
                            }
                        }
                    }

                }
                throw new ValidationError(message);
            // }
            // return errorResponse;
          });

        //window.axios = axios;

        const executeRequest = (url, params, method) => {
            const reqMethod = method.toLowerCase();
            let promise;
            switch (reqMethod) {
                case "get":
                    promise = httpClient.get(url, params);
                    break;
                case "post":
                    promise = httpClient.post(url, params);
                    break;
                case "put":
                    promise = httpClient.put(url, params);
                    break;
                case "delete":
                    promise = httpClient.delete(url, params);
                    break;
            }
            return promise;
        };

        const executeVuexRequest = (context, action, url, params, method = "get") => {
            context.commit(action, { meta: "PENDING", data: params });
            const reqPromise = executeRequest(url, params, method);
            return new Promise((resolve, reject) => {
                reqPromise
                    .then(response => {
                        context.commit(action, { meta: "SUCCESS", data: response });
                        resolve(response);
                    })
                    .catch(error => {
                        context.commit(action, { meta: "ERROR" });
                        reject(error);
                    });
            });
        };

        vue.$rest = {
            executeRequest: executeVuexRequest
        };

        vue.prototype.$rest = {
            executeRequest: executeVuexRequest
        }

    }
};
export default NetworkPlugin;
